module.exports = __webpack_public_path__ + "static/media/funnelTutorialSlide2.8aa83af0.svg";